export default __webpack_public_path__ + "static/media/stem.c2ac033c.jpg";